module.exports = "/assets/22c2929de2c9497cecb45d8e91a72567.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/6A.png
// module id = 2208
// module chunks = 0